module.exports = __webpack_public_path__ + "static/media/arrow-blue.9e84977f.svg";